import type { TransferProfilePhoneRequest } from '@/core/generated/api';
import { cleanPhone } from '@/shared/lib/phone';
import type { ProfilePhoneTransferFormValues } from './model/schema';

/** Подготавливает телефон и комментарий переноса профиля */
export const profilePhoneTransferFormToRequest = (
    values: ProfilePhoneTransferFormValues,
): TransferProfilePhoneRequest => ({
    phone: cleanPhone(values.phone) ?? values.phone.trim(),
    comment: values.comment.trim(),
});
